/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{c as o,g as r,f as c,n as s}from"../../chunks/vec32.js";import{create as t}from"../../core/libs/gl-matrix-2/factories/vec3f64.js";import{projectVectorToVector as e}from"./projectVectorToVector.js";function f(t,f,a,n,p){o(i,t),r(m,t,f),e(i,a,i,p),e(m,a,m,p),c(n,m,i),s(n,n)}const i=t(),m=t();export{f as projectDirection};
